import { render, staticRenderFns } from "./TransformationForm.vue?vue&type=template&id=5b95f8e6&scoped=true"
import script from "./TransformationForm.vue?vue&type=script&lang=js"
export * from "./TransformationForm.vue?vue&type=script&lang=js"
import style0 from "./TransformationForm.vue?vue&type=style&index=0&id=5b95f8e6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b95f8e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b95f8e6')) {
      api.createRecord('5b95f8e6', component.options)
    } else {
      api.reload('5b95f8e6', component.options)
    }
    module.hot.accept("./TransformationForm.vue?vue&type=template&id=5b95f8e6&scoped=true", function () {
      api.rerender('5b95f8e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/edit-page/import/transformations/TransformationForm.vue"
export default component.exports